<template>
  <div class="con-wrap">
    <p class="box-title">发电记录</p>
    <div class="data-wrap">
      <div class="query-box">
        <el-form size="mini" :inline="true" :model="queryDate" ref="queryDate">
          <el-form-item prop="time">
            <el-date-picker
              v-model.trim="queryDate.time"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="subjectNum">
            <el-input
              v-model.trim="queryDate.subjectNum"
              @keyup.enter.native="query"
              placeholder="工单编号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="type">
            <el-select
              v-model.trim="queryDate.type"
              placeholder="请选择发电类型"
              clearable
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button @click="reset">取消</el-button>
        </el-form>
      </div>
      <div class="data-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          size="mini"
          stripe
          height="560px"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column
            label="使用人"
            min-width="90"
            prop="ownerName"
          ></el-table-column>
          <el-table-column
            prop="subjectNum"
            label="工单编号"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="startTime"
            width="200"
            label="发电开始时间"
          ></el-table-column>
          <el-table-column
            prop="endTime"
            width="200"
            label="发电结束时间"
          ></el-table-column>
          <el-table-column
            prop="capacity"
            width="160"
            label="发电量（kW·h）"
          ></el-table-column>
          <el-table-column
            prop="duration"
            width="180"
            label="发电时长"
          ></el-table-column>
          <el-table-column
            prop="oil"
            width="160"
            label="发电油耗（升）"
          ></el-table-column>
          <el-table-column prop="vin" fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.stop="checkDetail(scope.row)"
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PowerRecord",
  props: {
    vin: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      queryDate: {
        time: "",
        type: 1,
        subjectNum: "",
      },
      typeList: [
        { id: 1, label: "有效", value: 1 },
        { id: 2, label: "无效", value: 2 },
        { id: 3, label: "全部", value: 3 },
      ],
      currentPage: 1,
      limit: 10,
      total: 0,
      tableData: [],
    };
  },
  created() {
    if (this.$route.params.currentPage) {
      this.currentPage = parseInt(this.$route.params.currentPage);
      this.queryDate.time = sessionStorage.getItem("powerTime");
      this.queryDate.type = parseInt(sessionStorage.getItem("powerType"));
    }
  },
  mounted() {
    this.getRefuelingData();
  },
  methods: {
    query() {
      this.getRefuelingData();
    },
    reset() {
      this.$resetForm(this, "queryDate");
      this.getRefuelingData();
    },
    async getRefuelingData() {
      let _this = this;
      let obj = {
        vin: _this.vin,
        type: _this.queryDate.type,
        date: _this.queryDate.time,
        subjectNum: _this.queryDate.subjectNum,
        limit: _this.limit,
        page: _this.currentPage,
      };
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/dynamo/counts",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
        _this.currentPage = res.data.currPage;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getRefuelingData();
    },
    checkDetail(data) {
      this.$router.push({
        name: "PowerRecordDetail",
        params: {
          vin: data.vin,
          id: data.id,
        },
      });
      sessionStorage.setItem("powerCurrPage", this.currentPage);
      sessionStorage.setItem("powerTime", this.queryDate.time);
      sessionStorage.setItem("powerType", this.queryDate.type);
    },
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  height: 100%;
  margin: 0;
  background-color: #fff;
}
.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}
.data-wrap {
  width: 100%;
  height: calc(100% - 31px);
  padding: 20px;
  box-sizing: border-box;
}
.el-form-item {
  margin-right: 20px !important;
}
.data-box {
  width: 100%;
  height: calc(100% - 84px);
}
#open-map {
  width: 100%;
  height: 580px;
}

div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}
</style>
